export default {
  default: [
    {
      path: "/",
      redirect: "/dashboard"
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: () => import("@/modules/dashboard/views/DashboardView.vue")
    }
  ]
};
